import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';

@Component({
  selector: 'app-login-wrapper-workers',
  templateUrl: './login-wrapper-workers.component.html',
  styleUrls: ['./login-wrapper-workers.component.css']
})
export class LoginWrapperWorkersComponent implements OnInit {

  perfil: 'paciente' | 'medico' = 'paciente';

  domainInfo: any = {};

  adsTransversal: any[] = [];
  currentIndexTransversal = 0;
  private transversalInterval: any;

constructor(
  private router: Router,
  private encriptacionService: EncriptacionService,
  private generalService: GeneralService
) {
  const url = window.location.pathname;
  this.perfil = url.includes('doctor') ? 'medico' : 'paciente';
}

cambiarPerfil(perfil: 'paciente' | 'medico') {
  if (perfil === this.perfil) return;
  this.perfil = perfil;
  this.router.navigateByUrl(perfil === 'paciente' ? '/login' : '/login-doctor');
}

  ngOnInit(): void {
    this.observerPageInfo();

    if(this.adsTransversal?.length > 1) {
       this.initTransversalBanner();
    }
  }

  async observerPageInfo() {
    
    while (true) {
      try {
        this.domainInfo = this.encriptacionService.getPageInfo();  
        this.adsTransversal = this.domainInfo.adsTransversal;
        // console.log(this.domainInfo,'this.domainInfo');
        
      } catch (error) {
        
      }
      if (this.domainInfo && this.domainInfo.cus_url_phone) {
        break;
      }
      await this.generalService.sleep(2000);
    }

  }

  /** Llama esto cada vez que setees adsTransversal desde el backend */
  initTransversalBanner(): void {
    this.stopTransversalAuto();

    if (!this.adsTransversal || this.adsTransversal.length === 0) {
      this.currentIndexTransversal = 0;
      return;
    }

    if (this.currentIndexTransversal >= this.adsTransversal.length) {
      this.currentIndexTransversal = 0;
    }

    if (this.adsTransversal.length > 1) {
      this.startTransversalAuto();
    }
  }

  startTransversalAuto(): void {
    this.transversalInterval = setInterval(() => {
      this.nextTransversal(false);
    }, 10000);
  }

  stopTransversalAuto(): void {
    if (this.transversalInterval) clearInterval(this.transversalInterval);
  }

  resetTransversalAuto(): void {
    if (!this.adsTransversal || this.adsTransversal.length <= 1) return;
    this.stopTransversalAuto();
    this.startTransversalAuto();
  }

  nextTransversal(resetTimer = true): void {
    if (!this.adsTransversal?.length) return;
    this.currentIndexTransversal = (this.currentIndexTransversal + 1) % this.adsTransversal.length;
    if (resetTimer) this.resetTransversalAuto();
  }
  
  closeTransversalBanner(): void {
    this.stopTransversalAuto();
    this.adsTransversal = [];
    this.currentIndexTransversal = 0;
  }

  goToTransversal(i: number): void {
    this.currentIndexTransversal = i;
    this.resetTransversalAuto();
  }

}
